<script setup lang="ts">
import { CfgButton, CfgTypography, CfgTypographySizes } from '@cfgtech/ui';
import { signOut } from 'aws-amplify/auth';
import { useEvents } from '~/composables/events/useEvents';

const { totalEvents, areEventsOpened } = useEvents({}, { lazy: true });

const router = useRouter();

const dataLayer = useDataLayer();

// methods
async function handleSignOut() {
  await signOut({ global: true });
  dataLayer.logout();
  router.push('/auth/login');
}
</script>

<template>
  <div class="card flex h-full max-h-[640px] flex-col !rounded-t-none bg-white">
    <div class="mt-8 px-4">
      <NuxtLink to="/portfolio">
        <CfgTypography class="text-grey-300" :size="CfgTypographySizes.h3">
          Můj Srovnávač
        </CfgTypography>
      </NuxtLink>
    </div>

    <div class="border-b border-grey-100 pt-3 text-grey-300" />

    <ul class="mt-5 flex flex-col">
      <li class="py-3">
        <NuxtLink
          active-class="!text-brand border-l-[6px] border-primary"
          class="px-4 py-3 text-secondary"
          to="/portfolio"
        >
          <CfgTypography :size="CfgTypographySizes.subtitle">
            Moje Dluhopisy
          </CfgTypography>
        </NuxtLink>
      </li>

      <li class="py-3">
        <NuxtLink
          active-class="!text-brand border-l-[6px] border-primary"
          class="px-4 py-3 text-secondary"
          to="/returns"
        >
          <CfgTypography :size="CfgTypographySizes.subtitle">
            Výplaty
          </CfgTypography>
        </NuxtLink>
      </li>

      <li class="py-3">
        <MenuButtonNews
          :total-count="totalEvents"
          @open="areEventsOpened = true"
        />
      </li>

      <li class="py-3">
        <NuxtLink
          active-class="!text-brand border-l-[6px] border-primary "
          class="px-4 py-3 text-secondary"
          to="/settings"
        >
          <CfgTypography :size="CfgTypographySizes.subtitle">
            Nastavení
          </CfgTypography>
        </NuxtLink>
      </li>

      <li class="py-3">
        <CfgButton
          class="px-4 text-secondary"
          text
          @click="handleSignOut"
        >
          <CfgTypography :size="CfgTypographySizes.subtitle">
            Odhlásit se
          </CfgTypography>
        </CfgButton>
      </li>
    </ul>

    <LazyAppEvents v-model:is-opened="areEventsOpened" />
  </div>
</template>
